/*
https://support.atlassian.com/statuspage/docs/what-are-the-different-apis-under-statuspage/

For the Status API, Atlassian doesn't allow CORS on private pages or trial pages.
The staging status page is a private page, so the call to the API fails.
It was decided that we could just use the prod links overall.
If we ever get around to proxying the request, then we can use the links below for the dev/staging.

STAGING_STATUS_PAGE_API_URL = 'https://crz5fygf73g7.statuspage.io/api/v2/components.json'
STAGING_STATUS_PAGE_URL = 'https://cashappstaging.statuspage.io/'

Relevant slack thread: https://cash.slack.com/archives/C0424B52UKX/p1685472629929559
*/

const STATUS_PAGE_API_URL = 'https://c2nqm6xyr4t4.statuspage.io/api/v2/components.json'
const STATUS_PAGE_URL = 'https://status.cash.app'

export { STATUS_PAGE_API_URL, STATUS_PAGE_URL }
